import { StyleSheet } from "react-native";
import Colors from "./Color";

const Fonts = StyleSheet.create({
  title: {
    fontSize: 32,
    fontWeight: "bold",
    marginBottom: 10,
    marginLeft: 10,
    color: Colors.blackColor,
  },
  bold30: {
    fontSize: 30,
    fontWeight: "bold",
    color: Colors.blackColor,
  },
  bold26: {
    fontSize: 26,
    fontWeight: "bold",
    color: Colors.blackColor,
  },
  bold24: {
    fontSize: 24,
    fontWeight: "bold",
    color: Colors.blackColor,
  },
  bold22: {
    fontSize: 22,
    fontWeight: "bold",
    color: Colors.blackColor,
  },
  bold20: {
    fontSize: 20,
    fontWeight: "bold",
    color: Colors.blackColor,
  },
  bold18: {
    fontSize: 18,
    fontWeight: "bold",
    color: "black",
    color: Colors.blackColor,
  },
  bold18Centered: {
    fontSize: 18,
    fontWeight: "bold",
    textAlign: "center",
    color: Colors.blackColor,
  },
  bold16: {
    fontSize: 16,
    fontWeight: "bold",
    color: Colors.blackColor,
  },
  bold16White: {
    fontSize: 16,
    fontWeight: "bold",
    color: Colors.whiteColor,
  },
  bold14: {
    fontSize: 14,
    fontWeight: "bold",
    color: Colors.blackColor,
  },
  bold12: {
    fontSize: 12,
    fontWeight: "bold",
    color: Colors.blackColor,
  },
  medium26: {
    fontSize: 26,
    fontWeight: "500",
    color: Colors.blackColor,
  },
  medium22: {
    fontSize: 22,
    fontWeight: "500",
    color: Colors.blackColor,
  },
  medium20: {
    fontSize: 20,
    fontWeight: "500",
    color: Colors.blackColor,
  },
  medium18: {
    fontSize: 18,
    fontWeight: "500",
    color: Colors.blackColor,
  },
  medium16: {
    fontSize: 16,
    fontWeight: "500",
    color: Colors.blackColor,
  },
  medium14: {
    fontSize: 14,
    fontWeight: "500",
    color: Colors.blackColor,
  },
  medium13: {
    fontSize: 13,
    fontWeight: "500",
    color: Colors.blackColor,
  },
  medium12: {
    fontSize: 12,
    fontWeight: "500",
    color: Colors.blackColor,
  },
  medium10: {
    fontSize: 10,
    fontWeight: "500",
    color: Colors.blackColor,
  },
  medium8: {
    fontSize: 8,
    fontWeight: "500",
    color: Colors.blackColor,
  },
  regular26: {
    fontSize: 26,
    fontWeight: "regular",
    color: Colors.blackColor,
  },
  regular22: {
    fontSize: 22,
    fontWeight: "regular",
    color: Colors.blackColor,
  },
  regular18: {
    fontSize: 18,
    fontWeight: "regular",
    color: Colors.blackColor,
  },
  regular16: {
    fontSize: 16,
    fontWeight: "regular",
    color: Colors.blackColor,
  },
  regular14: {
    fontSize: 14,
    fontWeight: "regular",
    color: Colors.blackColor,
  },
  regular13: {
    fontSize: 13,
    fontWeight: "regular",
    color: Colors.blackColor,
  },
  regular12: {
    fontSize: 12,
    fontWeight: "regular",
    color: Colors.blackColor,
  },
  regular10: {
    fontSize: 10,
    fontWeight: "regular",
    color: Colors.blackColor,
  },
});

export default Fonts;
